import InfiniteList from './InfiniteList';

export default InfiniteList;
